import React from 'react';

const ReactFragment = () => <></>;
export default ReactFragment;
